import { render } from "./AssignmentDetail.vue?vue&type=template&id=1536f892&scoped=true"
import script from "./AssignmentDetail.vue?vue&type=script&lang=js"
export * from "./AssignmentDetail.vue?vue&type=script&lang=js"

import "./AssignmentDetail.vue?vue&type=style&index=0&id=1536f892&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1536f892"]])

export default __exports__